<template lang="pug">
  #itinerary.right-panel.md-elevation-1.md-scrollbar.md-theme-default
    .entity-card
      .md-layout-row.entity-card-head
        .md-layout-item.entity-head-left
          span(v-if="$route.params.id") {{'Маршрутный лист №' + $route.params.id}}
          .status(v-if="result.status" v-bind:style="'color: ' + (result.status.color ? result.status.color : 'balck') + ';'") {{result.status.message}}
        .md-layout-item.entity-head-center
        .md-layout-item.entity-head-right
          md-button.md-icon-button.md-dense.close.small(v-on:click="back")
            md-icon close
            md-tooltip(md-direction="bottom" md-delay="500") Отменить

      .entity-card-body(v-loader-overlay="progress")
        .md-layout-item.entity-head-tight
          .md-body-1
            .sum-data-title Суммарная информация по выбранным грузам
            .sum-data
              .sum-data-item(md-with-hover)
                span {{'Вec (кг): '}}
                b {{parseFloat(result.weight).toFixed(2)}}
              .sum-data-item(md-with-hover) 
                span(v-html="'Объём (м<sup>3</sup>): '")
                b {{parseFloat(result.volume).toFixed(2)}}
              .sum-data-item(md-with-hover)
                span {{'Мест: '}}
                b {{result.seats}}

            .direction-container
              .direction-area__container
                .direction-area
                  z-big-select(
                      label="Выберите тип перевозки"
                      v-model="result.forward_type"
                      :required="true"
                      name="forward_type"
                      id="forward_type"
                      v-validate="'required|integer'"
                      v-bind:error="errors.first('forward_type')"
                      icon='<i class="far fa-clipboard"></i>'
                      disabled
                  )
                    z-select-item(v-for="item in types" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.value") 
                .direction-area
                  z-big-date(
                      v-bind:label="((parseInt(result.forward_type) === 1) ? 'Дата экспедирования' : 'Дата перевозки')"
                      v-model="result.date"
                      :required="true"
                      name="date"
                      id="date"
                      v-validate="'required'"
                      v-bind:error="errors.first('date')"
                      disabled
                  )
                .direction-area(v-if="result && result.forward_type && parseInt(result.forward_type) === 2")
                  z-big-select(
                    v-if="stocks && stocks.length"
                    label="Склад отправления"
                    v-model="result.from_stock_id"
                    :required="true"
                    name="from_stock_id"
                    id="from_stock_id"
                    v-validate="'required|integer'"
                    v-bind:error="errors.first('from_stock_id')"
                    v-bind:data-vv-as="' '"
                    icon='<i class="fas fa-warehouse"></i>'
                    disabled
                  )
                    z-select-item(v-for="item in stocks" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.name")

                  z-big-select(
                    v-if="responsiblesFrom && responsiblesFrom.length"
                    label="Кладовщик в пункте отправления"
                    v-model="result.from_storekeeper_id"
                    :required="true"
                    name="from_storekeeper_id"
                    id="from_storekeeper_id"
                    v-validate="'required|integer'"
                    v-bind:error="errors.first('from_storekeeper_id')"
                    v-bind:data-vv-as="' '"
                    icon='<i class="fas fa-people-carry"></i>'
                    disabled
                  )
                    z-select-item(v-for="item in responsiblesFrom" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.login")

                  z-big-select(
                    v-if="result.from_stock_id && drivers && drivers.length"
                    label="Водитель"
                    v-model="result.driver_id"
                    :required="true"
                    name="driver_id"
                    id="driver_id"
                    v-validate="'required|integer'"
                    v-bind:error="errors.first('driver_id')"
                    v-bind:data-vv-as="' '"
                    icon='<i class="fas fa-truck"></i>'
                    disabled
                  )
                    z-select-item(v-for="item in drivers" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.label")


                .direction-area(v-if="result && result.forward_type && parseInt(result.forward_type) === 2")
                  z-big-select(
                    v-if="stocks && stocks.length"
                    label="Склад назначения"
                    v-model="result.to_stock_id"
                    :required="true"
                    name="to_stock_id"
                    id="to_stock_id"
                    v-validate="'required|integer'"
                    v-bind:error="errors.first('to_stock_id')"
                    v-bind:data-vv-as="' '"
                    icon='<i class="fas fa-warehouse"></i>'
                    disabled
                  )
                    z-select-item(v-for="item in stocks" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.name")

                  z-big-select(
                    v-if="responsiblesTo && responsiblesTo.length"
                    label="Кладовщик в пункте назначения"
                    v-model="result.to_storekeeper_id"
                    :required="true"
                    name="to_storekeeper_id"
                    id="to_storekeeper_id"
                    v-validate="'required|integer'"
                    v-bind:error="errors.first('to_storekeeper_id')"
                    v-bind:data-vv-as="' '"
                    icon='<i class="fas fa-people-carry"></i>'
                    disabled
                  )
                    z-select-item(v-for="item in responsiblesTo" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.login")

                  z-big-select(
                    v-if="responsiblesTo && responsiblesTo.length"
                    label="Ответственный за прием машины в пункте назначения"
                    v-model="result.to_chief_id"
                    :required="true"
                    name="to_chief_id"
                    id="to_chief_id"
                    v-validate="'required|integer'"
                    v-bind:error="errors.first('to_chief_id')"
                    v-bind:data-vv-as="' '"
                    icon='<i class="fas fa-user-check"></i>'
                    disabled
                  )
                    z-select-item(v-for="item in responsiblesTo" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.login")

                .direction-area.full-width(v-if="result && result.forward_type && parseInt(result.forward_type) === 1")
                  z-big-select(
                    v-if="stocks && stocks.length"
                    label="Склад экспедирования"
                    v-model="result.stock_id"
                    :required="true"
                    name="stock_id"
                    id="stock_id"
                    v-validate="'required|integer'"
                    v-bind:error="errors.first('stock_id')"
                    v-bind:data-vv-as="' '"
                    icon='<i class="fas fa-warehouse"></i>'
                    disabled
                  )
                    z-select-item(v-for="item in stocks" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.name")

                .direction-area(v-if="result && result.forward_type && parseInt(result.forward_type) === 1")
                  z-big-select(
                    v-if="forwarders && forwarders.length"
                    label="Ответственный экспедитор"
                    v-model="result.forwarder_id"
                    :required="true"
                    name="forwarder_id"
                    id="forwarder_id"
                    v-validate="'required|integer'"
                    v-bind:data-vv-as="' '"
                    v-bind:error="errors.first('forwarder_id')"
                    icon='<i class="fas fa-truck-loading"></i>'
                    disabled
                  )
                    z-select-item(v-for="item in forwarders" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.login")

                .direction-area(v-if="result && result.forward_type && parseInt(result.forward_type) === 1")
                  z-big-select(
                    v-if="responsiblesFrom && responsiblesFrom.length"
                    label="Ответственный кладовщик"
                    v-model="result.storekeeper_id"
                    :required="true"
                    name="storekeeper_id"
                    id="storekeeper_id"
                    v-validate="'required|integer'"
                    v-bind:error="errors.first('storekeeper_id')"
                    v-bind:data-vv-as="' '"
                    icon='<i class="fas fa-people-carry"></i>'
                    disabled
                  )
                    z-select-item(v-for="item in responsiblesFrom" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.login")
            
              .direction-area__container
                .direction-area(v-if="vansAndTractors && vansAndTractors.length")
                  z-big-select(
                    label="Автомобиль"
                    v-model="result.auto_id"
                    :required="true"
                    name="auto_id"
                    id="auto_id"
                    v-validate="{'required': true}"
                    v-bind:error="errors.first('auto_id')"
                    v-bind:data-vv-as="' '"
                    icon='<i class="fas fa-truck"></i>'
                    disabled
                  )
                    z-select-item(v-for="item in vansAndTractors" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.label")
                
                .direction-area(v-if="trailers && trailers.length")
                  z-big-multy-select(
                    label="Прицеп"
                    v-model="result.trailers"
                    :required="true"
                    name="trailers"
                    id="trailers"
                    v-validate="{'required': true}"
                    v-bind:error="errors.first('trailers')"
                    v-bind:data-vv-as="' '"
                    icon='<i class="fas fa-trailer"></i>'
                    disabled
                  )
                    z-multy-select-item(
                      v-for="item in trailers" 
                      v-bind:value="item.id" 
                      v-bind:key="item.id" 
                      v-bind:label="item.label"
                      v-bind:selected="(result.trailers && (result.trailers.indexOf(item.id) + 1)) ? true : false"
                    )

                .direction-area(v-if="agents && agents.length")
                  z-big-select(
                    label="Агент (контрагент - исполнитель)"
                    v-model="result.agent_id"
                    :required="true"
                    name="agent_id"
                    id="agent_id"
                    v-validate="{'required': true}"
                    v-bind:error="errors.first('agent_id')"
                    v-bind:data-vv-as="' '"
                    icon='<i class="fas fa-user-tie"></i>'
                    disabled
                  )
                    z-select-item(v-for="item in agents" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.label")



            .freight-list-title.error(v-if="!selectedFreights || !selectedFreights.length")
              span.error Грузы не выбраны
            .freight-list-title(v-if="selectedFreights && selectedFreights.length")
              span.title Выбранные грузы
              span.error(v-if="hasFreightsErrors") (В списке грузов есть ошибки. Проверьте список грузов.)

            .freight-list(v-if="selectedFreights && selectedFreights.length")
              ZRLFreight(
                v-for="(freight, i) in selectedFreights"
                v-bind:key="('zrl-' + i + '-' + freight.id)"
                v-bind:freight="freight"
                v-bind:error="(freightsErrors[freight.id]) ? freightsErrors[freight.id] : null"
                v-on:remove="removeFreight(freight)"
                v-bind:show-remove="false"
                v-bind:storekeeper-view="true"
              )
            
      .entity-card-footer
        md-button.md-primary.small(v-show="($route.params.id && $route.params.id != 'new')" v-on:click="printDoc") Распечатать
</template>
<script>
  import moment from "moment"
  import ZSelect from '@/components/ZSelect';
  import ZSelectItem from '@/components/ZSelectItem';
  import ZBigSelect from '@/components/ZBigSelect';
  import ZBigMultySelect from '@/components/ZBigMultySelect';
  import ZMultySelectItem from '@/components/ZMultySelectItem';
  import ZBigDate from '@/components/ZBigDate';
  import ZRLFreight from '@/components/ZRLFreight';
  import autocomplete from '@/components/autocomplete'
  export default {
    components: {autocomplete, ZBigSelect, ZSelect, ZSelectItem, ZBigDate, ZRLFreight, ZBigMultySelect, ZMultySelectItem},
    data() {
      return {
        loadKey: 'load-itirnary-card',
        addFreight: {},
        selectedFreightsId: [],
        selectedFreights:[],
        responsibleItems: [],
        stockErrors: [],
        freightsErrors: {},
        canSave: true,
        responsibles: [],
        responsiblesFrom: [], //список кладовщиков на складе отправления
        responsiblesTo: [],   //список кладовщиков на складе назначения
        forwarders: [],       //список экспедиторов
        drivers: [],          //список водителей
        autos: [],
        agents: [],
        types: [
          {id: 1, value: 'Экспедирование'},
          {id: 2, value: 'Внутренняя перевозка'},
        ],
        currentStockId: null, //id склада, где находятся грузы
        currentCityId: null,
        result: {
          weight: 0,
          volume: 0,
          seats: 0,
          date: null,
          city: '',
          forwarder_id: null,
          from_storekeeper_id: null,
          to_storekeeper_id: null,
          storekeeper_id: null,
          to_chief_id: null,
          from_stock_id: null,
          to_stock_id: null,
          forward_type: null,
          driver_id: null,
          stock_id: null,
          auto_id: null,
          agent_id: null,
          trailers: [],
          freights: []
        },
        resultDefault: {
          weight: 0,
          volume: 0,
          seats: 0,
          date: null,
          city: '',
          forwarder_id: null,
          from_storekeeper_id: null,
          to_storekeeper_id: null,
          storekeeper_id: null,
          to_chief_id: null,
          from_stock_id: null,
          to_stock_id: null,
          forward_type: null,
          driver_id: null,
          stock_id: null,
          auto_id: null,
          agent_id: null,
          trailers: [],
          freights: []
        },
        routeList: {},
        hasFreightsErrors: false, //показывает, есть ли ошибки у грузов
      }
    },
    computed: {
      progress() {
        return this.progressObj[this.loadKey];
      },
      progressObj() {
        return this.$store.state.progressObj;
      },
      stateSelectedFreight() {
        return this.$store.state.stock.itineraryFreight
      },
      storeResponsibles() {
        return this.$store.state.stock.responsibles;
      },
      allFreights() {
        let freights = [], freight = {};
        if (this.$store.state.deals.deals && this.$store.state.deals.deals.length)
            this.$store.state.deals.deals.map(deal => {
                freight = Object.assign({}, deal.first_freight);
                freights.push(freight);
            });
        return freights;
      },
      stocks() {
        return this.$store.state.stock.stocks
      },
      user() {
        return this.$store.state.users.current;
      },
      endpoint() {
        return this.$store.state.endpoint;
      },
      //Автофургоны и Тягачи
      vansAndTractors() {
        if (!this.autos || !this.autos.length) return [];
        return this.autos.filter(auto => {
          return (parseInt(auto.type) === 1 || parseInt(auto.type) === 2);
        }).map(auto => {
          return {id: auto.id, label: (auto.brand + ', ' + auto.number)};
        });
      },
      //Прицепы
      trailers() {
        if (!this.autos || !this.autos.length) return [];
        return this.autos.filter(auto => {
          return (parseInt(auto.type) === 3);
        }).map(auto => {
          return {id: auto.id, label: (auto.brand + ', ' + auto.number)};
        });
      }
    },
    watch: {
        '$route.path'() {
          this.init();
          this.$store.commit('adaptiveSizePanel');
          this.$store.commit('openRightPanel');
        },
        'result.from_stock_id'(id, oldId) {
          if (id) this.getResponsibles(id, ['storekeepers', 'agent']).then(r => {
            if (r) this.responsiblesFrom = Object.assign([], r);
            else   this.responsiblesFrom = [];
          });
        },
        'result.to_stock_id'(id, oldId) {
          if (id) this.getResponsibles(id, ['storekeepers', 'agent']).then(r => {
            if (r) this.responsiblesTo = Object.assign([], r);
            else   this.responsiblesTo = [];
          });
        },
        'result.stock_id'(id, oldId) {
            if (id) this.getResponsibles(id, ['forwarders', 'agent']).then(r => {
              if (r) this.forwarders = Object.assign([], r);
              else   this.forwarders = [];
            });
            if (id) this.getResponsibles(id, ['storekeepers', 'agent']).then(r => {
              if (r) this.responsiblesFrom = Object.assign([], r);
              else   this.responsiblesFrom = [];
            });
        },
        'result.forward_type'(type) {
          this.getFreights();
        },
        'stateSelectedFreight'(val) {
          if (val && val.length) this.getFreights();
          else this.selectedFreights = [];
        },
        'addFreight'(val) {
            if (!val || !Object.keys(val) || !val.id) return;
            if (!(this.result.freights.indexOf(val.id)+1)) {
              let value = Object.assign({}, val);
              let itemVolume = this.prepareFreightVolume(value);
              this.result.weight = this.result.weight + parseFloat(value.weight);
              this.result.volume = parseFloat(this.result.volume) + itemVolume;
              this.result.seats  = this.result.seats  + parseInt(value.seats_number);

              this.selectedFreights.push(value);
              this.result.freights.push(value.id);
              this.addFreight = {};
              this.stockErrors = [];
            }
        },
        'result.date'() {
          this.stockErrors = [];
        },
    },
    methods: {
      init() {
        this.result = Object.assign({}, this.resultDefault);

        Promise.all([
          this.getStocks(),
          this.getDrivers(),
          this.getAutos(),
          this.getAgents()
        ]).finally(r => {
          
          if (this.$route.params.id && this.$route.params.id != 'new') {
            this.$store.commit('showSnackbar', ['Получение данных маршрутного листа, пожалуйста дождитесь полной загрузки формы...', 6000]);
            this.getRouteList(this.$route.params.id);
            this.result.id = this.$route.params.id;
          } else this.getFreights();
          
        });
        
        this.$store.commit('openRightPanel');
        this.$store.commit('adaptiveSizePanel');

        this.$validator.localize('ru', {
          attributes: {
            weight: 'Общий вес',
            volume: 'Общий объём',
            seats: 'Количество мест',
            date: 'Дата',
            forwarder_id: 'Экспедитор',
            freights: 'Грузы',
            forward_type: 'Тип перевозки',
            to_stock_id: 'Склад отправления',
            from_stock_id: 'Склад назначения',
            from_storekeeper_id: 'Кладовщик на складе отправления',
            to_storekeeper_id: 'Кладовщик на складе назначения',
            to_chief_id: 'Ответственный за прием машины на складе назначения',
          }
        });
      },

      getAgents() {
        return this.$store.dispatch('customers/getCustomers', {
          page: 1, order_by: 'id', order_type: 'asc', count: 'all', 
          filter: {model: [['is_agent', '=', 1]], relation: []}, cache: true
        }).then(agents => {
          if (agents && agents.length) this.agents = Object.assign([], agents.map(item => {
            return {
              id: item.id,
              label: item.name + ((item.inn) ? (', ' + item.inn) : ((item.passport_number) ? (', ' + item.passport_number) : ''))
            }
          }));
        });
      },
      getAutos() {
        return this.$store.dispatch('deals/getAutos', {page: 1, order_by: 'id', order_type: 'asc', count: 'all'}).then(autos => {
          if (autos && autos.length) this.autos = Object.assign([], autos);
        });
      },
      getDrivers() {
        if (this.drivers && this.drivers.length) return new Promise(resolve => resolve(this.drivers));
        return this.$store.dispatch('users/getUsers', {page: 1, order_by: 'id', order_type: 'asc', count: 'all', filter: {
          model: [], relation: [['groups', 'code', '=', 'driver']]
        }}).then(drivers => {
          this.drivers = Object.assign([], []);

          drivers.map(driver => {
            this.drivers.push({
              id: driver.id,
              label: (driver.fio ? driver.fio : '') + (driver.login ? ' (' +  driver.login + ')' : '')// + (groups.length ? ': ' + groups : '')
            });
          });

          return drivers;
        });
      },
      array_unique(array){
        return array.filter(function(el, index, arr) {
            return index == arr.indexOf(el);
        });
      },
      printDoc() {
          let url = this.endpoint + '/print/route_list_a4?route_list_id=' + this.$route.params.id + '&user_id=' + this.user.id
          window.open(url, '_blank');
      },
      getRouteList(id) {
        this.stockErrors = [];
        this.$store.commit('showProgressBar', this.loadKey);
        return this.$store.dispatch('deals/getRouteListById', id).then(r => {
          if (r) {
            this.routeList = Object.assign({}, r);
        
            this.result.id     = this.routeList.id;
            this.result.weight = this.routeList.weight;
            this.result.volume = this.routeList.size;
            this.result.seats  = this.routeList.seats;
            //this.result.date = this.routeList.date;
          
            this.routeList.date = this.routeList.date + 'T00:00:00.000Z';            
            this.$set(this.result, 'date', this.routeList.date);
            this.result.driver_id  = parseInt(this.routeList.driver_id);
            this.result.forwarder_id  = parseInt(this.routeList.forwarder_id);
            this.result.forward_type  = this.routeList.type;
            this.result.city          = this.routeList.city;
            this.result.from_stock_id = parseInt(this.routeList.from_stock_id);
            this.result.to_stock_id   = parseInt(this.routeList.to_stock_id);
            this.result.stock_id      = parseInt(this.routeList.stock_id);
            this.result.auto_id    = parseInt(this.routeList.auto_id);
            this.result.agent_id   = parseInt(this.routeList.agent_id);

            this.result.from_storekeeper_id = parseInt(this.routeList.from_storekeeper_id);
            this.result.to_storekeeper_id   = parseInt(this.routeList.to_storekeeper_id);
            this.result.storekeeper_id      = parseInt(this.routeList.storekeeper_id);
            this.result.to_chief_id         = parseInt(this.routeList.to_chief_id);
            this.result.status              = this.routeList.status;
            this.result.status_id           = parseInt(this.routeList.status_id);
            this.result.storekeeperFrom     = this.routeList.storekeeperFrom;
            this.result.storekeeperTo       = this.routeList.storekeeperTo;
            this.result.storekeeper         = this.routeList.storekeeper;
            this.result.chiefTo             = this.routeList.chiefTo;
            if (this.routeList.trailers && this.routeList.trailers.length)
              this.result.trailers = Object.assign([], this.routeList.trailers.map(auto => auto.id));

            this.$nextTick(() => {
              this.result.freights = [];
              this.routeList.freights.map(freight => this.result.freights.push(freight.id));
              this.prepareFreights();
            });
          }
        }).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
      },
      prepareFreights() { 
        if (this.routeList && this.routeList.freights) {
          this.selectedFreights   = Object.assign([], this.routeList.freights);
          this.selectedFreightsId = Object.assign([], this.routeList.freights.map(item => item.id));
        }
      },
      back(e) {
        this.$router.push({name: 'StorekeepersItineraries', query: this.$route.query});
      },
      getFreights() {
        this.currentStockId = null;
        this.canSave = true;

        if (this.$route.name == 'ItineraryFreights' && this.stateSelectedFreight && this.stateSelectedFreight.length && this.stateSelectedFreight.length != this.selectedFreights.length) {
          this.result.weight = 0;
          this.result.volume = 0;
          this.result.seats  = 0;
          this.result.freights = [];

          this.selectedFreights = [];
          this.stockErrors =  [];

          //Новая логика
          return this.$store.dispatch('deals/getFreightsByIds', {ids: this.stateSelectedFreight}).then(freights => {
            freights = (freights && freights.data) ? freights.data : []
            if (freights) freights.map(item => {
              let itemVolume = this.prepareFreightVolume(item);

              this.result.weight += parseFloat(item.weight);
              this.result.volume += itemVolume;
              this.result.seats  += parseInt(item.seats_number);
              this.result.freights.push(item.id);
              if (!this.result.forward_type) this.result.forward_type = item.forward_type;
              this.selectedFreights.push(item);
              return this.selectedFreights;
            });
         }).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
        }
      },
      getSizeUnits(unit) {
        let res = 0;
        switch (unit) {
          case 'm':  res = 'м'; break;
          case 'sm': res = 'см'; break;
          case 'mm': res = 'мм'; break;
          default:   res = 'м';
        }
        return res;
      },
      prepareFreightVolume(freight) {
        let itemSize = 0;
        switch (freight.size_units) {
          case 'м':  itemSize = parseFloat(freight.size); break;
          case 'm':  itemSize = parseFloat(freight.size); break;
          case 'см': itemSize = parseFloat(freight.size) / 100; break;
          case 'sm': itemSize = parseFloat(freight.size) / 100; break;
          case 'мм': itemSize = parseFloat(freight.size) / 1000; break;
          case 'mm': itemSize = parseFloat(freight.size) / 1000; break;
          default: itemSize = parseFloat(freight.size);
        }
        return itemSize;
      },
      getResponsibles(stockId, groups) {
        this.$store.commit('showProgressBar', this.loadKey);
        return this.$store.dispatch('stock/getStockResponsiblesFilter', {
          id: stockId,
          groups: groups
        }).then(r => {
            if (!r || !r.length) {
                this.stockErrors.push('К указанному складу, не добавлен ни один ответственный');
                return null;
            } else return Object.assign([], r.map(item => {
              let groups = [];
              if (item.groups && item.groups.length) item.groups.map(item => groups.push(item.name));
              groups = groups.join(', ');
              return {
                id: item.id, 
                login: (item.fio ? item.fio : '') + (item.login ? ' (' +  item.login + ')' : '') + (groups.length ? ': ' + groups : '')
              }
            }));
        }, r => null).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
      },
      filterFreight(searchString) {
        if (searchString.length >= 3) return this.$store.dispatch('stock/searchFreights', {
            filter : {model: [['traking_number', '%', searchString]], relation: []}
        });
      },
      removeFreight(freight) {
        this.result.freights = [];
        let freights = [], ids = [];
        
        this.selectedFreights.map(item => {
          if (parseInt(item.id) !== parseInt(freight.id)) {
            this.result.freights.push(item.id);
            ids.push(item.id);
            freights.push(item);
          }
        });

        this.$store.commit('stock/changeItineraryFreight', ids);
        this.$store.commit('showSnackbar', ['Груз удалён из маршрутного листа', 6000, 'success']);
      },
      getStocks() { //получение всех складов
        this.$store.commit('showProgressBar', this.loadKey);
        this.$store.dispatch('stock/getStocks', {page: 1, count: 100, order_by: 'id', order_type: 'asc'});
      },
      getCity() {
        if (!this.result || !this.result.forward_type || !this.stocks || !this.stocks.length) return '';
        let stock = null;
        switch ( parseInt(this.result.forward_type) ) {
          case 1: //Забор у отправителя
            stock = this.stocks.find(stock => parseInt(stock.id) === parseInt(this.result.from_stock_id));
          break;
          case 2: //Выдача получателю
            stock = this.stocks.find(stock => parseInt(stock.id) === parseInt(this.result.to_stock_id));
          break;
          case 3: //Внутренняя перевозка
            stock = this.stocks.find(stock => parseInt(stock.id) === parseInt(this.result.to_stock_id));
          break;
        }
        if (!stock || !stock.city || !stock.city.name) return '';
        return stock.city.name;
      }
    },
    mounted() {
      this.$nextTick(() => this.init());
      this.$root.$on('update-itinerary-form', (id) => {
        if (parseInt(id) == parseInt(this.$route.params.id)) this.init();
      });
    }
  }
</script>
<style lang="sass">
  #itinerary
    .md-layout-item.entity-head-left
      display: flex
      align-items: center
      justify-content: flex-start
      .status
        margin: 0 0 0 10px
    .freight-list-title
      margin: 0 0 5px 0
      .title
        margin: 0 10px 0 0
    .freight-list
      .freight-list-item__container
        margin: 0 0 10px 0
        .freight-list-item
          margin: 0
        .freight-list-item__errors
          padding: 5px 0 0 0
          .freight-list-item__error
            display: flex
            align-items: center
            justify-content: flex-start
            .error-text
              color: red
              font-size: 12px
            .md-icon
              color: red
              font-size: 20px !important
              margin: 0 2px 0 0
              width: 20px
              height: 20px
              min-height: 20px
              min-width: 20px
        .md-card-header
          padding: 10px
          .md-title
            display: flex
            align-items: center
            justify-content: space-between
            margin: 0
            font-size: 14px
            line-height: 14px
            position: relative
            sup
              font-size: 14px
              line-height: 0px
            .close-btn
              display: flex
              align-items: center
              justify-content: center
              width: 22px
              height: 22px
              opacity: 0
              position: absolute
              top: -22px
              right: -22px
              background: rgba(255, 49, 49, 0.91)
              border-radius: 100%
              transition: 0.25s ease-in-out
              .md-icon
                color: #fff
                width: 18px
                height: 18px
                min-width: 18px
                font-size: 18px !important
        .md-card-content
          padding: 0 10px 10px 10px
        .freight-list-item__content
          display: flex
          flex-wrap: wrap
          .freight-list-item__content-item
            width: 100%
            display: flex
            align-items: flex-start
            justify-content: space-between
            .place
            .date
      .freight-list-item__container:hover
        .md-card-header
          .close-btn
            opacity: 1
      .freight-list-item__container.has-error
        .freight-list-item
          border: 1px solid rgb(255, 113, 113)
            
    .error
      color: red
    .success
      color: green


    .direction-container
      background: #FAFAFA
      padding: 20px 10px 15px 10px
      margin: 0 -10px 10px -10px
    .direction-area__container
      display: flex
      align-items: flex-start
      justify-content: space-between
      flex-wrap: wrap
      .direction-area
        width: calc(50% - 5px)
        &.full-width
          width: 100%


    .sum-data-title
      margin: 0 0 10px 0
    .sum-data
      display: flex
      align-items: stretch
      justify-content: space-between
      margin: 0 0 20px 0
      .sum-data-item
        display: flex
        align-items: center
        justify-content: center
        background: #FAFAFA
        border: 1px solid #2196F3
        box-sizing: border-box
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25)
        border-radius: 3px
        height: 33px
        width: calc(33% - 10px)
        font-size: 12px
        line-height: 12px
        span
          margin: 0 5px 0 0
        sup
          line-height: 0px
      .sum-data-item:nth-child(2)
        margin: 0px 10px
</style>



// WEBPACK FOOTER //
// StorekeepersItinerary.vue?ca17431c